import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import { IBooking } from '../../common/types/apiSchema';

export { GET_BOOKING, IBookingDetailsQueryData, IBookingDetailsQueryVariables };

const GET_BOOKING: DocumentNode = gql`
  query getBookingById($bookingId: String!) {
    booking(bookingId: $bookingId) {
      id
      transactionId
      title
      status
      saleLocation {
        city {
          id
          name
        }
        country {
          id
          name
        }
        continent {
          id
          name
        }
        division {
          id
          name
        }
        latitude
        longitude
      }
      leadImage {
        url
        urlWithSize
        caption
      }
      bookingDates {
        start
        end
      }
      amendedDates {
        start
        end
      }
      duration
      rooms
      occupancy {
        adults
        children
      }
      links {
        printConfirmationEmail
        sendConfirmationEmail
        printPdfInvoice
      }
      hotelDetails {
        address {
          line1
          line2
          line3
          line4
          line5
        }
        customerSupportNumber
        customerSupportEmail
      }
      cancellationPolicy {
        properties {
          key
          value
        }
        isCancellable
        isRebookable
        notCancellableReason
      }
    }
  }
`;
interface IBookingDetailsQueryData {
  booking: IBooking;
}

interface IBookingDetailsQueryVariables {
  bookingId: string;
}
